import React from "react";

/**
 * Slim brand-promise strip that sits directly above the Footer on every page.
 * Presents the "Own Your Mind → Lead Yourself → Take Control" mantra in three
 * gently-progressive words, so the site closes on intent, not navigation.
 */
const STEPS = [
  { label: "Own Your Mind", tone: "primary" },
  { label: "Lead Yourself", tone: "secondary" },
  { label: "Take Control", tone: "accent" },
];

const PromiseStrip = () => (
  <section className="md-promise-strip" data-testid="promise-strip" aria-label="MindDhara promise">
    <div className="md-container md-promise-strip-inner">
      {STEPS.map((s, i) => (
        <React.Fragment key={s.label}>
          <span className={`md-promise-step md-promise-step-${s.tone}`} data-testid={`promise-step-${i}`}>
            {s.label}
          </span>
          {i < STEPS.length - 1 && (
            <span className="md-promise-arrow" aria-hidden="true">→</span>
          )}
        </React.Fragment>
      ))}
    </div>
  </section>
);

export default PromiseStrip;
